var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoundMute = function SvgSoundMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M29.92 1.846a.85.85 0 0 0-1.202.005l-7.931 8V3.52l-8.522 6.971H10.53c-.63 0-1.104.162-1.578.649-.473.486-.631.972-.631 1.62v6.161c0 .649.316 1.135.631 1.622.238.162.515.325.792.446l-7.897 7.965-.019.02a.849.849 0 0 0 1.226 1.175l8.723-8.798.063.008 8.948-9.057v-.04l9.138-9.215.019-.02a.85.85 0 0 0-.025-1.181m-9.133 26.183-7.464-6.287 7.464-7.555zm0 0 .158.133h-.158z",
    clipRule: "evenodd"
  })));
};
export default SvgSoundMute;